import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/industries/government')({
  head: () => ({
    ...buildSeoHead({ path: '/industries/government', ...ROUTE_META['/industries/government'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Industries', path: '/industries' }, { name: 'Government', path: '/industries/government' }])),
      jsonLdScript(buildWebPageSchema({ path: '/industries/government', ...ROUTE_META['/industries/government'] })),
    ],
  }),
});
